import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const { VITE_AI_HOST } = import.meta.env;

export const aiService = createApi({
  reducerPath: 'aiService',
  baseQuery: fetchBaseQuery({ baseUrl: VITE_AI_HOST }),
  endpoints: (builder) => ({
    isHealthy: builder.query<boolean, void>({
      query: () => ({
        method: 'GET',
        url: '/',
        headers: { Accept: 'text/plain; charset=utf-8' },
        responseHandler: (response) => response.text()
      }),
      transformResponse: async (text: string): Promise<boolean> => {
        return text.trim() === 'Ollama is running';
      },
      keepUnusedDataFor: 30 /* seconds */
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  // \n
  useIsHealthyQuery
} = aiService;
